import React from 'react'
import { Form } from 'antd';
import FormControls from '../../../../../components/form/FormControls/FormControls';
import Memo from '../../../../../components/hoc/Memo';
import TextArea from 'antd/lib/input/TextArea';

type TagFormInputsProps = {
    handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
    clearForm?: () => void
    resetChanges?: () => void
    submitForm: () => void
}

export const TagFormInputs: React.FC<React.PropsWithChildren<TagFormInputsProps>> = (props) => {
    const {
        handleChange, clearForm, submitForm,
        resetChanges,
    } = props

    return (
        <>
            <Memo hdl={handleChange}>
                <Form.Item
                    name="name"
                    label="Название тега"
                    className="uif-ant-form-item"
                >
                    <TextArea rows={4} onChange={e => handleChange(e)} />
                </Form.Item>
            </Memo>

            <FormControls
                submitForm={submitForm}
                resetChanges={resetChanges}
                clearForm={clearForm}
            />
        </>
    )
}

export default TagFormInputs